import { ReactElement, useState } from "react";
import {
    useCreateTemplatePropertyMutation
} from "../../../__generated__/generated_types";
import { Close, Modal } from "@zendeskgarden/react-modals";
import { toast } from "react-toastify";
import TemplatePropertyForm, { TTemplatePropertyRecord } from "./components/template-property-form/TemplatePropertyForm";
import { ThemeProvider } from "styled-components";
import { ViziblyTheme } from "../../../styles/zendesk-garden/ViziblyZDGTheme";

export interface ICreateTemplateProperty {
    formVisible: boolean,
    onModalClose: () => void,
    onCreate: () => void,
    budgetYear: number,
}

export function TemplatePropertyCreateModal(props: ICreateTemplateProperty): ReactElement {
    const { formVisible, onModalClose, onCreate } = props;

    const [createTemplateProperty, { loading: createLoading }] = useCreateTemplatePropertyMutation({
        notifyOnNetworkStatusChange: true,
        onCompleted: data => {
            if (data && data.createTemplateProperty) {
                toast.success(`Template property "${data.createTemplateProperty.name}" created`);
                onCreate();
            }
            reset();
        },
    });

    const [templateProperty, setTemplateProperty] = useState<TTemplatePropertyRecord>({
        name: "",
        isDeactivated: false,
        reforecastStartMonthIndex: 0,
    });

    function updateTemplateProperty(update: Partial<TTemplatePropertyRecord>): void {
        setTemplateProperty({
            ...templateProperty,
            ...update,
        });
    }

    function doSaveTemplateProperty(): void {
        createTemplateProperty({
            variables: {
                name: templateProperty.name,
                isDeactivated: templateProperty.isDeactivated,
                reforecastStartMonthIndex: templateProperty.reforecastStartMonthIndex,
                budgetYear: props.budgetYear
            }
        }).catch(() => { /* Error handling is done via onError in Apollo client */ });
    }

    function reset(): void {
        setTemplateProperty({
            name: "",
            isDeactivated: false,
            reforecastStartMonthIndex: 0,
        });
        onModalClose();
    }

    if (!formVisible) {
        return <></>;
    }

    return (
        <ThemeProvider theme={ViziblyTheme}>
            <Modal onClose={reset}>
                <TemplatePropertyForm
                    isCreate
                    templateProperty={templateProperty}
                    loading={createLoading}
                    onChange={updateTemplateProperty}
                    onSubmit={doSaveTemplateProperty}
                    onClose={reset}
                />
                <Close aria-label="Close modal" />
            </Modal>
        </ThemeProvider>
    );
}
